import {Requirement, VexCluster} from 'types';
import {TFunction} from 'react-i18next';
import {
	IHTMLXL,
	IArrayRoles,
	renderHeaderXL,
	renderHTMLExcel,
	cleanHTMLExcel,
	createZIPXL,
} from './ExcelExportCommon';
import Excel from 'exceljs';
import {formatDateTime} from 'i18n/localeDateFormat';
import i18n from 'i18n/i18n';

interface IRequirementPage {
	(
		entityListItems: any[],
		columnNames: string[],
		arrRoles: IArrayRoles,
		myVexClusters: VexCluster[],
		t: TFunction,
	): Promise<void>;
}

export const handleClickRequirements: IRequirementPage = async (
	entityListItems,
	columnNames,
	arrRoles,
	myVexClusters,
	t,
) => {
	let filtRequirement = entityListItems as Requirement[];

	if (arrRoles.isVex) {
		filtRequirement = filtRequirement.filter(x =>
			x.vexClusters.some(vc => myVexClusters.some(mvc => mvc.id === vc.id)),
		);
	}

	const arrImagesUri: string[] = [];
	const arrImagesName: string[] = [];
	const arrTables: string[] = [];

	const tOptions = {ns: 'features/requirements'};
	const workbook = new Excel.Workbook();
	const sheet = workbook.addWorksheet(
		'TRACE_' +
			t('RequirementsHeader', {
				ns: 'features/requirements',
			}),
	);
	const columns = columnNames.map(x => {
		return {name: x, filterButton: true};
	});
	const arrColWidth: number[] = [
		15,
		40,
		...new Array(3).fill(25),
		80,
		...new Array(8).fill(25),
	];
	const strPageName = t('RequirementsHeader', tOptions);

	renderHeaderXL(workbook, sheet, arrColWidth, strPageName, t);

	let intRowCount = 4;
	let row = sheet.getRow(intRowCount);
	row.font = {
		bold: true,
		name: 'Porsche Next TT',
		size: 10,
		color: {argb: 'FFFFFFFF'},
	};

	sheet.addTable({
		name: 'tableRequirements',
		ref: 'B' + String(intRowCount),
		style: {
			showRowStripes: true,
		},
		columns,
		rows: [],
	});

	const table = sheet.getTable('tableRequirements');

	intRowCount++;
	const tempDivElement = document.createElement('div');
	let arrHTMLXL: IHTMLXL[];
	let arrHTMLXLClean: IHTMLXL[];

	if (filtRequirement.length === 0) {
		table.addRow(['', '', '', '', '', '', '', '', '', '']);
		intRowCount++;
	}

	for (let ii = 0; ii < filtRequirement.length; ii++) {
		arrHTMLXL = [];
		arrHTMLXLClean = [];
		const iRequirement = filtRequirement[ii];
		tempDivElement.innerHTML = iRequirement.definition
			? '<div>' + iRequirement.definition + '</div>'
			: '<div></div>';
		renderHTMLExcel(tempDivElement.childNodes[0].childNodes, arrHTMLXL);
		cleanHTMLExcel(arrHTMLXL, arrHTMLXLClean);

		row = sheet.getRow(intRowCount);
		row.alignment = {wrapText: true, vertical: 'top'};
		row.getCell('D').style.font = {
			underline: true,
			bold: false,
			color: {argb: '00B0F0'},
		};
		table.addRow([
			(iRequirement.attachments ?? []).map(x => x.attachmentId).join(';\n'),
			iRequirement.name,
			{
				text: iRequirement.requirementId,
				hyperlink: window.location.origin + '/requirements/' + iRequirement.id,
			},
			iRequirement.vexClusters.map(cluster => cluster.name).join(';\n'),
			t(iRequirement.status ?? '', {
				ns: 'common/enums',
				keyPrefix: 'RequirementStatus',
			}),
			{richText: arrHTMLXLClean, wrapText: true, vertical: 'top'},
			iRequirement.systemLevels.map(level => level.name).join(';\n'),
			iRequirement.markets.map(market => market.name).join(';\n'),
			iRequirement.keywords.map(keyword => keyword.name).join(';\n'),
			iRequirement.tags.map(tags => tags.name).join(';\n'),
			iRequirement.createdBy.name,
			iRequirement.modifiedAt
				? formatDateTime(new Date(iRequirement.modifiedAt), i18n)
				: '',
			t(iRequirement.category, {
				ns: 'common/enums',
				keyPrefix: 'RequirementCategory',
			}),
			iRequirement.version ?? '',
		]);

		intRowCount++;

		for (
			let jj = 0;
			jj < tempDivElement.getElementsByTagName('img').length;
			jj++
		) {
			arrImagesUri.push(
				tempDivElement
					.getElementsByTagName('img')[0]
					.getAttribute('src') as string,
			);
			arrImagesName.push(
				(iRequirement.requirementId as string) + '_' + jj + '.html',
			);
			row = sheet.getRow(intRowCount);
			row.outlineLevel = 1;
			row.getCell('B').fill = {
				type: 'pattern',
				pattern: 'solid',
				fgColor: {argb: '8DB4E2'},
			};
			row.getCell('G').alignment = {
				indent: 1,
				wrapText: true,
				vertical: 'top',
			};
			row.getCell('G').style.font = {
				underline: true,
				bold: false,
				color: {argb: '00B0F0'},
			};
			table.addRow([
				'',
				'',
				'',
				'',
				'',
				{
					text: t('LinkImage', {ns: 'components/EntityList/ExcelExport'}),
					hyperlink:
						(('assets/' + iRequirement.requirementId) as string) +
						'_' +
						jj +
						'.html',
					tooltip: t('Link', {
						ns: 'components/EntityList/ExcelExport',
						keyPrefix: 'TooltipsText',
					}),
				},
			]);
			intRowCount++;
		}
	}

	table.commit();

	const strZipName = t('RequirementsHeader', {ns: 'features/requirements'});
	await createZIPXL(
		workbook,
		strZipName,
		t,
		arrTables,
		arrImagesUri,
		arrImagesName,
		[],
	);
};
